import { initialFormState } from '../constants/constant'
import {
  CLEAR_PLANOGRAM_EDITION_DATA,
  GET_PLANOGRAM_EDITION_DATA,
  SET_STORE_SELECTION_AND_TAB,
} from './types'

const prePlanReducer = (state = initialFormState, action) => {
  switch (action.type) {
    case GET_PLANOGRAM_EDITION_DATA:
      return {
        // ...state,
        ...action.payload,
      }
    case CLEAR_PLANOGRAM_EDITION_DATA:
      return {
        ...action.payload,
      }
    case SET_STORE_SELECTION_AND_TAB:
      return {
        ...state,
        store: action.payload.store,
        tab: action.payload.tab,
      }
    default:
      return state
  }
}

export default prePlanReducer
